import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f3480c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center align-items-center flex-column" }
const _hoisted_2 = { class: "title my-3 my-lg-5" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "description d-flex" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "※", -1))
const _hoisted_10 = { class: "description d-flex" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "◆", -1))
const _hoisted_12 = { class: "description d-flex" }
const _hoisted_13 = { class: "ms-2" }

import Button from '@/components/button/index.vue'
import { useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import { watchEffect } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const checkSubmit = localStorage.getItem('checkSubmit')

watchEffect(() => {
  if (!checkSubmit) router.push('/alumni/register_alumnus')
})

const transitAlumniLogin = () => {
  router.push('/alumni/login')
  localStorage.removeItem('checkSubmit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('SA22title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('SA22descriptionFirst')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('SA22descriptionSecond')), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(translate)('SA22descriptionThird')), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('SA22descriptionFourth')), 1),
      _createElementVNode("p", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", null, _toDisplayString(_unref(translate)('SA22descriptionFifth')), 1)
      ]),
      _createElementVNode("p", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", null, _toDisplayString(_unref(translate)('SA22descriptionSixth')), 1)
      ]),
      _createElementVNode("p", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(translate)('SA22onlyMail')), 1)
      ])
    ])
  ]))
}
}

})